import {useState} from 'react'
import {DynamicColumnTable} from '@/components/organisms'
import {getCellDataMappedCols} from '@/helpers/dataTableCellDataMapper'
import {useActivites} from '@/containers/Activity/useActivites'
import {getSelectedRowData} from '@/utils/commons'
import {Icon, LinkText} from '@/components/atoms'

const cellDataMapperObj = {
  activityTitle: ({row: {original} = {}}) => {
    return (
      <div>
        <LinkText
          text={original?.activityTitle}
          id={original?.activityTitle + ' ' + original?.id}
          handleClick={() => {}}
        />
      </div>
    )
  },
  customers_count: ({row: {original} = {}}) => {
    return <div className="txtRightAlign">{original?.numberOfCustomers}</div>
  },
  percent_completed: ({row: {original} = {}}) => {
    return <div className="txtRightAlign">{original?.percentageCompleted}</div>
  },
  points_awarded: ({row: {original} = {}}) => {
    return <div className="txtRightAlign">{original?.totalPointsAwarded}</div>
  },
  status: ({row: {original} = {}}) => {
    return <div className={original?.status === 'Cancelled' ? 'status_error' : ''}>{original?.status}</div>
  },
}

export const SalesTargetsActivitiesList = () => {
  const {activityListData, activityLColConfigData, setPageIndex, setSortingObj, setSearchArry, onDownloadBtnClick} =
    useActivites()

  const [rowSelected, setRowSelected] = useState([])

  const cellDataMappedCols = getCellDataMappedCols(cellDataMapperObj, activityLColConfigData)

  const selectedDataList = getSelectedRowData(rowSelected, activityListData?.data)

  const extractIds = () => selectedDataList.map(item => item?.activityId)

  const isLoading = !activityListData?.data || activityLColConfigData?.length === 0

  const onDownloadClick = async () => {
    onDownloadBtnClick(extractIds())
  }

  return (
    <div className="salesTargetsActiviesDataTable">
          <DynamicColumnTable
            isLoading={isLoading}
            columns={cellDataMappedCols || []}
            records={activityListData?.data || []}
            rowSelection={rowSelected}
            setRowSelection={setRowSelected}
            toolbarActions={[
              {
                iconLeading: <Icon icon="download" size="small" />,
                text: 'Download',
                variant: 'secondary',
                onClick: () => {
                  onDownloadClick()
                },
              },
            ]}
            setPageIndex={setPageIndex}
            setSearchArry={setSearchArry}
            setSortingObj={setSortingObj}
          />
          {activityListData?.totalRecords && (
            <div className="txtRightAlign">{activityListData?.totalRecords} total items</div>
          )}
    </div>
    )
}
